import { Tracker } from 'flux-core';
import { IDataItemUIControl } from './data-items-uic.i';
import { map, tap } from 'rxjs/operators';
import { Component, ChangeDetectionStrategy, ElementRef, Input } from '@angular/core';
import { Observable, BehaviorSubject, fromEvent } from 'rxjs';
import { IDataItem } from 'flux-definition';

/**
 * This is an input component that has a title
 * The title can be positioned on the top or left
 */
@Component({
    selector: 'check-box-uic',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <div>
            <input #input type="checkbox" class="fx-hidden" [checked]="valueSource | async">
            <svg style="cursor:pointer;" (click)="input.click()" *ngIf="(valueSource | async)" tabindex="0" class="nu-icon toolbar-icon on">
                <use [attr.xlink:href]="'./assets/icons/symbol-defs.svg#nu-ic-checkbox-slide-on'" ></use>
            </svg>
            <svg style="cursor:pointer;" (click)="input.click()" *ngIf="!(valueSource | async)" tabindex="0" class="nu-icon toolbar-icon off">
                <use [attr.xlink:href]="'./assets/icons/symbol-defs.svg#nu-ic-checkbox-slide-off'" ></use>
            </svg>
        </div>
    `,
})
export class CheckBoxUIC implements IDataItemUIControl<boolean> {

    /**
     * For tracking purpose only.
     * This property is to identify where this component is being used.
     */
     @Input()
     public context?: string;

    /**
     * A unique id for the input.
     * This must be set at all times.
     */
    public id: string;


    public valueSource: BehaviorSubject<boolean>;

    /**
     * Constructor
     */
    constructor( protected elementRef: ElementRef ) {
        this.valueSource = new BehaviorSubject( false );
    }

    /**
     * An observable that emits when the button is clicked.
     * If an extenal component wants to listen to the button
     * click event, they need to subscribe to this observable.
     */
    public get change(): Observable<boolean> {
        const input  = ( this.elementRef.nativeElement as HTMLElement ).querySelector( 'input' );
        return fromEvent( input, 'click' ).pipe(
            map(() => input.checked ),
            tap(() => {
                /* istanbul ignore next */
                if ( this.context ) {
                    Tracker.track( `${this.context}.checkbox.change` );
                }
            }),
        );
    }

    /**
     * Sets data to the button.
     */
    public setData( data: IDataItem<any> ) {
        this.valueSource.next( data.value );
    }

}
